import React from "react";
import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";

import { B20VALI } from "../../../Validation";
import { FormControl } from "react-bootstrap";
import { Box } from "react-bootstrap-icons";
import moment from "moment";
import ComponentLoader from "../../../../ComponentLoader";

function B20Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [eventName, setEventName] = useState("");
  const [titleofthetalk, setTitleofthetalk] = useState("");
  const [eventdate, setEventdate] = useState("");
  const [numberofparticipants, setNumberofparticipants] = useState("");
  const [sponsor, setSponsor] = useState("");
  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);
  const [loader,setLoader] =useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(B20VALI),
  });

  const backs = () => {
    navigate("/B20");
  };

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("Plenary lecture delivered");
  }, []);
  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
    setLoader(false);
  }, []);

  const edit = (item) => {
    console.log(item);
    setValue("EventNameV", item.eventName);
    setValue("TitleofthetalkV", item.titleofthetalk);
    setValue("EventdateV",moment(item.rptDate).format("YYYY-MM-DD"));
    setValue("NumberofparticipantsV", item.numberofparticipants);
    setValue("SponsorV", item.sponsor);

    setId(item.id);
  };

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  const handleLeavepage = async (data) => {
    console.log(data);
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);

    const d = {
      id,
      EventName: data.EventNameV,
      Titleofthetalk: data.TitleofthetalkV,
      Eventdate: data.EventdateV,
      Numberofparticipants: data.NumberofparticipantsV,
      Sponsor: data.SponsorV,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.B20SAVE}`,
          d,
          { headers: h }
        );
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/B20");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }

        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.B20EDIT}`,
          d,
          { headers: h }
        );
        console.log(data);

        if (data.result === "Success") {
          alert("Succesfully Submitted");
          navigate("/B20");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div className="main-container-margin">
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>Plenary lecture delivered (B20)</span>
        </div>
      </div>

      <form className="from-mains" onSubmit={handleSubmit(handleLeavepage)}>
        <div className="form-control">
          <h5 style={{ width: 450, margin: 20 }}>
            B20. Invited / Plenary lecture delivered
          </h5>

          <TextField
            id="outlined-basic"
            label="Name of the Event"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            // value={FellowshipName}

            onChange={(e) => setEventName(e.target.value)}
            {...register("EventNameV")}
            error={errors.EventNameV ? true : false}
            helperText={errors.EventNameV?.message}
          />

          <TextField
            id="outlined-basic"
            label="Title of the Talk (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            // value={Noofclassesoffered}

            onChange={(e) => setTitleofthetalk(e.target.value)}
            {...register("TitleofthetalkV")}
            error={errors.TitleofthetalkV ? true : false}
            helperText={errors.TitleofthetalkV?.message}
          />

          <TextField
            id="outlined-basic"
            label=" Date"
            type="date"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                placeholder: "",
              }}
            {...register("EventdateV")}
            error={errors.EventdateV ? true : false}
            helperText={errors.EventdateV?.message}
          />

          <TextField
            id="outlined-basic"
            label="Number of Participants"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            // value={NoOfStudent}
            // onChange={(e) => setNumberofparticipants(e.target.value)}

            {...register("NumberofparticipantsV")}
            error={errors.NumberofparticipantsV ? true : false}
            helperText={errors.NumberofparticipantsV?.message}
          />

          <TextField
            id="outlined-basic"
            label="Sponsor"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            // value={NoOfStudent}
            // onChange={(e) => setSponsor(e.target.value)}

            {...register("SponsorV")}
            error={errors.SponsorV ? true : false}
            helperText={errors.SponsorV?.message}
          />

          <div className="from-last">
            <button
              type="submit"
              style={{ backgroundColor: "#008CBA", height: "20px" }}
              onClick={backs}
            >
              Back
            </button>
            <button type="submit" className="sbmit-buttons">
            Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default B20Inside;
